import EcomProjectionVsActualChart from 'components/charts/e-charts/EcomProjectionVsActualChart'
import React from 'react'

const EcomProjectionVsActual = () => {
  return (
    <div className="me-xl-4">
      <div>
        <h3>Revenue Summary</h3>
        <p className="mb-1 text-body-tertiary">Purchase vs Income</p>
      </div>
      <EcomProjectionVsActualChart height="300px" width="100%" />
    </div>
  )
}

export default EcomProjectionVsActual
